import React from 'react'
import BigOrangeButton from '../../components/Buttons/BigOrangeButton/BigOrangeButton'
import TextCentered from '../../components/Sections/TextCentered/TextCentered'
import VidLeftTextRight from '../../components/Sections/VidLeftTextRight/VidLeftTextRight'
import "./Home.css"

export default function Home() {
  return (
    <div className='home__container'>
      <div className='home__top-section'>
        <h1>Boost Your Sales And Grow Your Business...</h1>
        <h1 className='home__sub-title'>Without Compromising Who You Are!</h1>
      </div>
      <div className='home__section-up'>
      <VidLeftTextRight />
      <br />
      <TextCentered />
      <br />
      
        <BigOrangeButton
          location="/form"
          text="Yes! I Want To Start This Funnel!"
      />
      </div>
    </div>
  )
}
